const statusFormatter = (cell?: string) => {
  const key = (cell ?? "").toString().toUpperCase();
  const tone =
    key === "COMPLETED"
      ? "ok"
      : key === "STOP" || key === "STOPPED"
        ? "stop"
        : "muted";
  return <span className={`pill pill--${tone}`}>{key || "—"}</span>;
};

const percentFormatter = (cell?: string | number) => {
  const n =
    typeof cell === "string"
      ? parseFloat(cell.replace("%", ""))
      : typeof cell === "number"
        ? cell
        : 0;
  const pct = isFinite(n) ? Math.max(0, Math.min(100, n)) : 0;
  return (
    <div className="pct">
      <div className="pct__bar">
        <div className="pct__fill" style={{ width: `${pct}%` }} />
      </div>
      <span className="pct__label">{pct.toFixed(0)}%</span>
    </div>
  );
};

const FORMATTERS: Record<string, any> = {
  status: statusFormatter,
  success: percentFormatter,
};

export const injectFormatters = (cols: any[]) => {
  return cols.map((c) => {
    const df = (c.dataField || "").toString().toLowerCase();

    if (FORMATTERS[df]) {
      return {
        ...c,
        formatter: FORMATTERS[df],
        headerStyle: {
          ...(c.headerStyle || {}),
          width: c.dataField === "status" ? 140 : c.headerStyle?.width,
        },
      };
    }

    if (
      !FORMATTERS[df] &&
      typeof c.text === "string" &&
      c.text.toLowerCase() === "status"
    ) {
      return {
        ...c,
        formatter: statusFormatter,
        headerStyle: { ...(c.headerStyle || {}), width: 140 },
      };
    }

    return c;
  });
};

export const formatDisplayName = (name?: string | null) => {
  if (!name) return "";
  const local = name.split("@")[0];

  const spaced = local.replace(/[._]+/g, " ").replace(/\s+/g, " ").trim();
  return spaced
    .split(/([ -])/g)
    .map((item) =>
      /^[ -]$/.test(item)
        ? item
        : item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()
    )
    .join("");
};
